import { render, staticRenderFns } from "./MenuPermissao.vue?vue&type=template&id=213e0d3a"
import script from "./MenuPermissao.vue?vue&type=script&lang=js"
export * from "./MenuPermissao.vue?vue&type=script&lang=js"
import style0 from "./MenuPermissao.vue?vue&type=style&index=0&id=213e0d3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports